import { NoImage } from "@assets/constant/index.constant";
import { Clock } from "@assets/icons";
import { Badge } from "@components/ui/badge";
import { Switch } from "@components/ui/switch";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { isFutureDate, isNullCheck } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";

const ColumnList = ({ toggleActiveStatus }: { toggleActiveStatus: any }) => {
  const { handleAction } = useHandleAction({});
  return [
    {
      name: "ID",

      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row?.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Title/Description",
      cell: (row: any) => (
        <div className="flex items-center gap-3">
          <ZoomImage>
            <img
              src={row.media || NoImage}
              alt="featured"
              onError={(e: any) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = NoImage;
              }}
              className="object-cover w-12 h-12 border rounded-md "
            />
          </ZoomImage>
          <div className="flex gap-1 flex-col">
            {" "}
            <h2 className="max-w-[150px] w-fit truncate">{row.title}</h2>
            <p
              className="line-clamp-1 max-w-[150px]"
              dangerouslySetInnerHTML={{
                __html: row.description,
              }}
            ></p>
          </div>
        </div>
      ),
      sortable: false,
    },

    {
      name: "Category",
      cell: (row: any) => (
        <Tooltip description={row.category.name}>
          <div className="text-lg capitalize font-semibold text-gray-800">
            <Badge
              className="max-w-[250px] text-yellow-500 truncate"
              variant={"warning"}
            >
              {isNullCheck(row.category.name) as string}
            </Badge>
          </div>
        </Tooltip>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3  cursor-pointer">
          <Switch
            checked={row?.is_show}
            onCheckedChange={(value) => toggleActiveStatus(row?.id, value)}
            className="cursor-pointer"
          />
          {row?.auto_expiration_date && !!row?.auto_expiration && (
            <Tooltip description={row.auto_expiration_date}>
              <Clock
                color={
                  isFutureDate(`${row?.auto_expiration_date}`) ? "green" : "red"
                }
              />
            </Tooltip>
          )}
          <button
            className="text-[#1DA077]"
            onClick={() => handleAction({ type: "page-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className="text-[#C33241]"
            onClick={() =>
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              })
            }
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

const CategoryColumnList = () => {
  const { handleAction } = useHandleAction({});
  return [
    {
      name: "ID",
      width: "400px",

      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row?.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Name",
      width: "400px",
      cell: (row: any) => (
        <div className="text-lg capitalize font-semibold text-gray-800">
          <Tooltip description={row.name}>
            <div className="flex justify-start text-gray-800">
              <span className="text-start w-fit max-w-[150px] truncate">
                {row.name}
              </span>
            </div>
          </Tooltip>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3  cursor-pointer">
          <button
            className="text-[#1DA077] cursor-pointer"
            onClick={() => handleAction({ type: "modal-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className="text-[#C33241] cursor-pointer"
            onClick={() =>
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              })
            }
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

const DurationColumnList = () => {
  const { handleAction } = useHandleAction({});
  return [
    {
      name: "ID",
      width: "400px",

      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row?.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Name",
      width: "400px",
      cell: (row: any) => (
        <div className="text-lg capitalize font-semibold text-gray-800">
          <Tooltip description={row.duration}>
            <div className="flex justify-start text-gray-800">
              <span className="text-start  w-fit max-w-[150px] truncate">
                {row.duration}
              </span>
            </div>
          </Tooltip>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3  cursor-pointer">
          <button
            className="text-[#1DA077] cursor-pointer"
            onClick={() => handleAction({ type: "modal-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className="text-[#C33241] cursor-pointer"
            onClick={() =>
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              })
            }
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

export { CategoryColumnList, ColumnList, DurationColumnList };
